import React from "react"
import TextBlock from "../index"

const Success = ({ children, padding }) => {
  return <TextBlock theme="success" children={children} padding={padding} />
}

export default Success
